export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-300 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-fill text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">
                吃瓜爆料
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              国内领先的娱乐热点与爆料聚合平台。汇集全网最新吃瓜爆料黑料、吃瓜爆料视频与吃瓜爆料每日大赛精彩内容，每日热点爆料吃瓜不断更新。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#about" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">关于我们</a></li>
              <li><a href="#topics" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">热门话题</a></li>
              <li><a href="#index" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">专题合集</a></li>
              <li><a href="#faq" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容板块</h4>
            <ul className="space-y-2.5">
              <li><a href="#updates" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">热点快讯</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">热搜榜单</a></li>
              <li><a href="#media" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">热门视频</a></li>
              <li><a href="#carousel" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer">焦点专题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-foreground-500">合作品牌持续入驻中</span></li>
              <li><span className="text-sm text-foreground-500">媒体资源互换与合作</span></li>
            </ul>
            <div className="mt-5">
              <h4 className="text-sm font-semibold text-background-50 mb-3">联系我们</h4>
              <p className="text-sm text-foreground-400">
                <i className="ri-mail-line mr-1.5"></i>tougao@chigua-baoliao.com
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 吃瓜爆料. 本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#hero" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#hero" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer">投稿须知</a>
          </div>
        </div>
      </div>
    </footer>
  );
}